import React from 'react';
import { InView } from 'react-intersection-observer';

const Intersection = ({ children, page, handleInViewChange, listId }) => {
  return (
    <InView
      onChange={(inView, entry) => handleInViewChange({ inView, page })}>
      {({ ref }) => (
        <div id={`product-listing-${listId}-page-${page}`} ref={ref}
             className="grid-2 tablet:grid-3 laptop:grid-4">{children}</div>
      )}
    </InView>
  );
};

export default Intersection;
